import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import Layout from '../../components/layoutComponent';
import { Container } from '../../components/styles/blocks';

export async function getStaticProps({ locale }) {
  return {
    props: {
      ...(await serverSideTranslations(locale, ['common', 'teaser'])),
    },
  };
}

export default function Faq() {
  return (
    <Layout>
      <Container>
        <br/><br/>
        
        <iframe width="100%" height="512" src="https://www.youtube-nocookie.com/embed/E-oqmDpFu_w" title="YouTube video player" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
        
        <br/><br/>

        <iframe width="100%" height="512" src="https://www.youtube-nocookie.com/embed/SgZqlRrWKko" title="YouTube video player" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
        
        <br/><br/>
      </Container>
    </Layout>
  );
}
